export default "https://cdn-static.gokick.com/assets/9232f824e6a46c896411df64bf74cb68df4bd809/images/logo.fe82f4ad349e614dc769d17dbf45d7bb.svg";